var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDosystemudozowaniaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.55 52.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.16,
    cy: 29.76,
    r: 6.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.23,14.88c0-1.42-1.15-2.57-2.57-2.57h-15.91c-1.42,0-2.57,1.15-2.57,2.57v3.59h21.04v-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.14,24.12v9.44c0,1.42,1.15,2.57,2.57,2.57h20.01c1.42,0,2.57-1.15,2.57-2.57v-9.44c0-1.42-1.15-2.57-2.57-2.57h-20.01c-1.42,0-2.57,1.15-2.57,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.36,31.17v3.18c2.38.76,4.11,2.99,4.11,5.62,0,3.25-2.65,5.9-5.9,5.9h-11.74c.13.5.19,1.02.19,1.54s-.07,1.04-.19,1.54h11.74c4.95,0,8.98-4.03,8.98-8.98,0-4.34-3.09-7.97-7.18-8.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 20.73,
    cy: 47.42,
    rx: 8.21,
    ry: 5.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.59,18.47h1.03v2.18c.5-.08,1.02-.13,1.54-.13s1.04.04,1.54.13v-2.18h1.03c.85,0,1.54-.69,1.54-1.54s-.69-1.54-1.54-1.54h-1.03v-6.67c0-3.11,2.53-5.64,5.64-5.64h30.48c3.11,0,5.64,2.53,5.64,5.64s-2.53,5.64-5.64,5.64h-.51v3.08h.51c4.81,0,8.72-3.91,8.72-8.72S48.63,0,43.82,0H13.34C8.53,0,4.62,3.91,4.62,8.72v6.67h-1.03c-.85,0-1.54.69-1.54,1.54s.69,1.54,1.54,1.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDosystemudozowaniaIcon);
export default __webpack_public_path__ + "static/media/Do systemu dozowania_icon.3b8f71bda6c1c426cabdc5bda5c0a3de.svg";
export { ForwardRef as ReactComponent };